<script>
  import CookieLaw from 'vue-cookie-law'

  export default {
    components: {CookieLaw}
  }
</script>

<template>
  <footer>
    <cookie-law theme="afterlife"
                :buttonText="$t('message.cookiePopup.ok')"
                :message="$t('message.cookiePopup.message')"
                position="bottom"
                transitionName="fade">
    </cookie-law>
  </footer>
</template>

<style>
  .Cookie--afterlife {
    background: #343a40;
    color: #fff;
    padding: 1.250em;
    white-space: pre-line;
  }

  .Cookie--afterlife .Cookie__button {
    background: #007bff;
    padding: 0.625em 3.125em;
    color: #fff;
    border-radius: 0;
  }

  .Cookie--afterlife div.Cookie__button:hover {
    background: #0069d9;
  }

  .Cookie--afterlife .Cookie__content {
    margin-left: 10%;
    margin-right: 10%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/CookiePopup.vue